import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import { bindPhone } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew } from "@/mixins/index";
export default {
  mixins: [gmToolNew],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        gate_user_id: "",
        game_id: "",
        env_id: "",
        phone: ""
      },
      rules: {
        phone: [{
          required: true,
          message: this.$t('pleaseEnterPhoneNumber'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.formData.game_id = _this.rawData.game_id;
                _this.formData.env_id = _this.paramsData.env_id;

                if (data) {
                  _this.formData.gate_user_id = data.gate_user_id;
                  _this.formData.phone = data.phone;
                }

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 7;
                    break;
                  }

                  if (/^1[3-9]\d{9}$/.test(_this2.formData.phone)) {
                    _context2.next = 4;
                    break;
                  }

                  _this2.$message.error(_this2.$t('phoneNumberIncorrect'));

                  return _context2.abrupt("return");

                case 4:
                  bindPhone(_objectSpread({}, _this2.formData)).then(function (res) {
                    if (res.status == 200) {
                      _this2.$message({
                        message: _this2.$t('operationSuccess'),
                        type: 'success'
                      });

                      _this2.dialogFormVisible = false;

                      _this2.$emit('change');
                    }
                  });
                  _context2.next = 8;
                  break;

                case 7:
                  return _context2.abrupt("return", false);

                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    clearData: function clearData() {
      this.formData.gate_user_id = "";
      this.formData.game_id = "";
      this.formData.env_id = "";
      this.formData.phone = "";
    }
  }
};